import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5363ef6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "options" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-radio" }, null, -1))
const _hoisted_4 = ["innerHTML"]

interface Props {
  options: string[];
  modelValue: number[];
}

interface Emits {
  (event: 'update:model-value', val: number[]): void;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    options: null,
    modelValue: null
  },
  emits: ["update:model-value"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'update:model-value', val: number[]): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  options: string[];
  modelValue: number[];
}




function toggleChecked(index: number) {
  const $value = new Set(props.modelValue);
  if ($value.has(index)) {
    $value.delete(index);
  } else {
    $value.add(index);
  }
  emits('update:model-value', [...$value]);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: _normalizeClass(["item", { active: __props.modelValue.includes(index) }]),
        onClick: ($event: any) => (toggleChecked(index))
      }, [
        _hoisted_3,
        _createElementVNode("div", { innerHTML: item }, null, 8, _hoisted_4)
      ], 10, _hoisted_2))
    }), 128))
  ]))
}
}

})